import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {BaseEndpointService} from '../base-endpoint-service';
import {ListItem} from '../../../entities/list-item.entity';
import TimeTrackingEntry = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingEntry;
import TimeTrackingEntryData = Backend.App.Data.Dashboard.TimeTracking.TimeTrackingEntryData;

@Injectable({providedIn: 'root'})
export class TimeTrackingEntryService extends BaseEndpointService<TimeTrackingEntry, TimeTrackingEntryData> {
  protected override endpoint = '/time-tracking/entries';

  public override modelToMultiSelectItem(m: TimeTrackingEntry): ListItem & { model: TimeTrackingEntry; } {
    return {
      id: m.id,
      text: m.id,
      isDisabled: false,
      model: m,
    }
  }
}
